import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { ModalService } from 'src/app/services/modal.service';
import { ValidatorService } from 'src/app/services/validator.service';

@Component({
  selector: 'voucher-email-modal',
  templateUrl: './voucher-email-modal.component.html',
  styleUrls: ['./voucher-email-modal.component.scss']
})
export class VoucherEmailModalComponent implements OnInit {

  public email  = null;
  public id     = null;
  public loader = false;
  public dataItem = {
    email: "",
    id: null
  }
  public paymentLink:any = false;

  constructor(
    public dialog: MatDialogRef<VoucherEmailModalComponent>,
    @Inject(MAT_DIALOG_DATA) public d,
    private api: ApiService,
    private modal: ModalService,
    private validator: ValidatorService
  ){

    this.dataItem.email = this.d.email;
    this.dataItem.id    = this.d.id;
    this.paymentLink    = this.d.paymentLink;  

  }
  
  /**
   * 
   * Send
   * 
   */
  send(){

    try{

      this.validator.clear();
      this.validator.isEmpty(this.dataItem.email,"email","- Informe o E-mail para recebimento do voucher.");
      
      if(!this.validator.passes()){

        this.modal.open(this.validator.getMessagesHtml());  
        return false;

      }

      this.loader = true;

      if(this.paymentLink == false || this.paymentLink == "false"){

        this.api.sale().order().voucher().email(this.dataItem).subscribe(response => {

          this.loader = false;

          if(response.status == 1){

            this.modal.open(`O voucher foi enviado para o email: <strong>${this.dataItem.email}</strong>`)

          }else{

            let error   = this.api.formatError(response);
            this.modal.open(error.message);

          }

        },(response) => {

          this.loader = false;
          let error   = this.api.formatError(response);
          this.modal.open(error.message);

        });

      }else{

        this.api.paymentLink().order().voucher().email(this.dataItem).subscribe(response => {

          this.loader = false;

          if(response.status == 1){

            this.modal.open(`O voucher foi enviado para o email: <strong>${this.dataItem.email}</strong>`)

          }else{

            let error   = this.api.formatError(response);
            this.modal.open(error.message);

          }

        },(response) => {

          this.loader = false;
          let error   = this.api.formatError(response);
          this.modal.open(error.message);

        });

      }
      

    }catch(e){

      this.loader = false;
      this.modal.open(e.message);

    }


  }
  /**
   * 
   * Init
   * 
   */
  ngOnInit():void{}

}
